import { gql } from '@apollo/client';

export const CREATE_SETI_FOR_PAYMENT_CHANGE = gql`
  mutation wInitChangePM($uid: UUID!, $local: Boolean!) {
    wInitChangePM(uid: $uid, local: $local)
  }
`;
